import { queryOptions } from "@tanstack/react-query";
import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

function superbillMetaDataFromApiData(data: any): SuperBillMetaData {
  return {
    modify_datetime: new Date(data.modify_datetime),
    orchid_pro_cognito_sub: data.orchid_pro_cognito_sub,
    patient_cognito_sub: data.patient_cognito_sub,
    appointment_ids: data.appointment_ids,
    statement_no: data.statement_no,
    last_revision: data.last_revision,
    unique_id_for_email: data.unique_id_for_email,
    patient_request: data.patient_request
      ? new Date(data.patient_request)
      : undefined,
    orchid_pro_finalized: data.orchid_pro_finalized
      ? new Date(data.orchid_pro_finalized)
      : undefined,
    orchid_pro_rejected: data.orchid_pro_rejected
      ? new Date(data.orchid_pro_rejected)
      : undefined,
    orchid_pro_reject_reason: data.orchid_pro_reject_reason,
    issue_date: data.issue_date ? new Date(data.issue_date) : undefined,
    appointment_start: data.appointment_start,
    orchid_pro_pending_fill: data.orchid_pro_pending_fill,
    patient_pending_fill: data.patient_pending_fill,
    generate_state: data.generate_state,
    pending_update_reason: data.pending_update_reason,
  };
}

const superbillByAppointmentIdsQueryOptions = (params: {
  appointmentIds: string[];
  onBehalfOf?: string;
}) => {
  return queryOptions({
    queryKey: ["superbillByAppointmentIds", params],
    queryFn: async ({ signal }) => {
      const url = `/api/scheduler/v1/superbill/appointments/get_by_appointment_ids${
        params.onBehalfOf ? `?on_behalf_of=${params.onBehalfOf}` : ""
      }`;

      const res = await fetchOrchidAPI(url, {
        signal,
        method: "POST",
        body: JSON.stringify({
          appointment_ids: params.appointmentIds,
        }),
      });
      if (!res.ok) {
        throw new Error(getErrorDetail(await res.text()));
      }
      const json = await res.json();
      return (json as any[]).map(superbillMetaDataFromApiData);
    },
  });
};

export default superbillByAppointmentIdsQueryOptions;
